
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whs2023",
      function () {
        return require("private-next-pages/whs2023/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whs2023"])
      });
    }
  